import { configureStore } from '@reduxjs/toolkit';
import { debounce } from "../helpers/helpers";
import authReducer from './authSlice';
import { loadState, saveState } from './browser-storage';
import censusProfileSlice from './censusProfileSlice';
import clientProfileReducer from './clientProfileSlice';
import issuesProfileSlice from './issuesProfileSlice';
import parkProfileReducer from './parkProfileSlice';
import specieProfileSlice from './specieProfileSlice';
import statesReducer from './statesSlice';
import stopsProfileSlice from './stopsProfileSlice';
import tableReducer from './tableSlice';
import userProfileReducer from './userProfileSlice';
import sidebarSliceReducer from './sidebarSlice';

const store = configureStore({
  reducer: {
    //@ts-ignore
    auth: authReducer,
    table: tableReducer,
    userProfile:   userProfileReducer,
    clientProfile: clientProfileReducer,
    parkProfile:   parkProfileReducer,
    statesProfile: statesReducer,
    specieProfile: specieProfileSlice,
    issuesProfile: issuesProfileSlice,
    stopsProfile:  stopsProfileSlice,
    censusProfile: censusProfileSlice,
    sidebarSlice:  sidebarSliceReducer,
  },
  preloadedState: loadState(),
});

// here we subscribe to the store changes
store.subscribe(
  // we use debounce to save the state once each 800ms
  // for better performances in case multiple changes occur in a short time
  debounce(() => {
    saveState(store.getState());
  }, 800));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;